<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>Available Project Packing Lists</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12">
                    <v-combobox
                        v-model="packingList"
                        :items="availablePackingLists"
                        item-text="longName"
                        hide-details
                        prepend-icon="mdi-package-variant-closed"
                        placeholder="Select a Packing List: "
                    >
                    </v-combobox>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                color="primary"
                class="mb-4"
                @click="openProcessPackingList"
                rounded
                :loading="loading"
                :disabled="!packingList"
            >
                OPEN
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'ExistentPackingLists',
    props: {
        packingLists: {
            type: Array,
            required: true,
        },
        project: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        packingList: null,
        availablePackingLists: [],
    }),
    async mounted() {
        try {
            this.loading = true

            this.packingLists.forEach(
                pl =>
                    (pl.longName = `${pl.code} - ${pl.status} - ${
                        pl.scheduledFor ? pl.scheduledFor : 'Not scheduled'
                    }`)
            )
            this.availablePackingLists = this.packingLists.filter(
                p =>
                    p.projectId == this.project.id &&
                    ['inProgress', 'rejected'].includes(p.status)
            )
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async openProcessPackingList() {
            try {
                this.packingList.packingListId = this.packingList.id
                this.$emit('openProcessPackingList', this.packingList)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style></style>
